var React = require('react');

function IconUserflow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M21.667 20.333L16.333 15v-4.24a4 4 0 1 0-2.667 0V15l-5.333 5.333H3V27h6.667v-4.067l5.333-5.6 5.333 5.6V27H27v-6.667z","transform":"rotate(-90 12 15)"}));
}

IconUserflow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconUserflow;

IconUserflow.default = IconUserflow;
